import { vehicleTypes } from './VehicleType';

export const mainCategoryParams = [...vehicleTypes] as const;
export const combinedMainCategoryParams = [
  ...vehicleTypes,
  'transport_and_machinery'
] as const;

export type MainCategory = (typeof mainCategoryParams)[number];
export type CombinedMainCategory = (typeof combinedMainCategoryParams)[number];
